'use es6';

import { createSelector } from 'reselect';
const getReviewsState = state => state.profile.reviews;
export const getReviewFilters = createSelector([getReviewsState], state => state.filters);